module.exports = __webpack_public_path__ + "media/reskin-images/icon--help-362f09bb.svg";